export default {"src":"/_next/static/image/public/images/ic_star_yellow.7689efce038129ab82a7ff933ab94fad.svg","height":29,"width":30};